(ns frontend.view.settings2.export-data.view
  (:require
   [common.dates :as dates]
   [common.localization :as loc]
   [common.util :as cu :refer [empty-string equals? only-entity]] 
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.components.spinner :as spinner]
   [frontend.view.not-found :as not-found]
   [frontend.view.settings2.export-data.db :as db]
   [frontend.view.settings2.export-data.events :as events]
   [frontend.view.settings2.security.view :as security-view]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.alert.view :as alert]
   [ui.components.breadcrumbs.view :as breadcrumbs]))

(defonce state (r/atom {}))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [e]
                 (routing/set-view! [:account-settings :tab-key "data"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/excel-export)]])

(defn export-to-excel
  []
  (let [exporting? (:exporting? @db/state)
        latest-export (->> @session/all-attachments
                           (cu/only-entity :attachment/type :attachment.type/export)
                           (cu/only-entity :attachment/description "data export")
                           (sort-by :attachment/created)
                           last
                           :attachment/created)
        alert (-> @db/state
                  :alerts
                  :export)
        now (.getTime (dates/date-time))

        ;;TODO replace with the 24h one below after testing:
        ;less-than-24h-since-last? (< now (+ latest-export (* 1000 60)))
        less-than-24h-since-last? (< now (+ latest-export (* 1000 3600 24))) 
        button-disabled? (or exporting? less-than-24h-since-last?)]
    [:div
     {:class "flex flex-col gap-4"}
     [:div
      {:class "flex flex-col gap-4"}
      [:span
       {:class "text-xl font-bold"}
       (loc/tr :settings/export-to-excel)]
      [:div
       {:class "flex flex-col gap-4"}
       [:div
        {:class "text-base-light-text-paler"}
        (loc/tr :settings/export-to-excel-info)]

       (when alert
         [alert/danger
          {:on-close    (partial events/hide-alert! :export)
           :class "mb-3"}
          alert])

       (when exporting?
         [:div
          [spinner/view]])

       [:div 
         [button/secondary-hollow
          {:disabled? button-disabled?
           :on-click  (when-not button-disabled?
                        events/export-data!)
           :tooltip (if less-than-24h-since-last?
                      (loc/tr :tooltip/wait-to-export-again)
                      (loc/tr :export-button))}
          (loc/tr (if less-than-24h-since-last? :export-too-soon-for-new-export :export-button))]]]]]))

(defn component
  []
  (r/create-class
   {:component-did-mount
    (fn [_])
    :component-will-unmount
    (fn [_])
    :reagent-render
    (fn []
      (let []
        [:<>
         [zap-toolbar/view state breadcrumbs nil nil #_(toolbar-actions feature-on?) nil]
         [:div
          {:class "px-4 py-6 mx-auto max-w-5xl"}
          [:div
           {:class "flex flex-col gap-4"}
           [:div
            {:class "flex flex-col gap-4"}
            [export-to-excel]
            [security-view/export-activity]]]]]))}))

(defmethod routing/render-view :new-settings/export-data
  [_]
  (if (session/is-admin?)
    [default-page-layout/view
     [component]]
    [not-found/not-found-view]))
